import { render, staticRenderFns } from "./myTests.vue?vue&type=template&id=0dc6ba77&scoped=true"
import script from "./myTests.vue?vue&type=script&lang=js"
export * from "./myTests.vue?vue&type=script&lang=js"
import style0 from "./myTests.vue?vue&type=style&index=0&id=0dc6ba77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6ba77",
  null
  
)

export default component.exports